/**
 * DOLM IT brand block — same logo + wordmark + subtitle the Nav renders,
 * but standalone (no router / no role state). Used by the auth pages
 * (login, change-password) which sit outside the SPA shell.
 */
import type { FC } from "react";

import { DOLMIT } from "../tokens";

// SVG artwork extends to y≈50 — viewBox is taller than wide so the rendered
// height tracks the real bounds (logoSize is the width; height scales to
// match the 44×50 aspect so the bottom chevron doesn't get clipped).
const LOGO_VIEW_W = 44;
const LOGO_VIEW_H = 50;

export const BrandHeader: FC<{ size?: "lg" | "md" }> = ({ size = "lg" }) => {
  const C = DOLMIT;
  const logoSize = size === "lg" ? 36 : 26;
  const wordSize = size === "lg" ? 18 : 13.5;
  const subSize = size === "lg" ? 11 : 9;
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12 }}>
      <svg
        width={logoSize}
        height={logoSize * (LOGO_VIEW_H / LOGO_VIEW_W)}
        viewBox={`0 0 ${LOGO_VIEW_W} ${LOGO_VIEW_H}`}
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M43.154 15.38L6.585 36.55l.699.4h.05l2.544 1.498 33.276-19.274v3.795L13.221 40.396l.698.4 2.594 1.497 26.641-15.529v3.795L19.806 44.241l.748.4 2.545 1.497 20.055-11.784v3.795l-16.713 9.936-3.292 1.898-3.293-1.947-2.594-1.498-.749-.4-3.292-1.947-2.595-1.498-.698-.4-3.293-1.947-3.342-1.898L0 36.501l3.293-1.897 39.861-23.02z"
          fill={C.blue}
        />
        <path
          d="M43.154 34.354L6.685 13.282l.699-.4 2.594-1.497 33.176 19.174v-3.795L13.271 9.487l.648-.4h.05l2.544-1.497 26.641 15.38v-3.796L19.806 5.692l.748-.4L23.1 3.796l20.055 11.584v-3.795L26.391 1.897 23.1 0l-3.293 1.897-2.544 1.498-.749.4-3.242 1.897-2.595 1.498-.698.4-3.293 1.897-3.293 1.898L.1 13.282l3.292 1.898 39.762 22.969z"
          fill={C.blue}
        />
      </svg>
      <div style={{ textAlign: "left" }}>
        <div
          style={{
            fontSize: wordSize,
            fontWeight: 700,
            color: C.navyDeep,
            letterSpacing: -0.2,
            fontFamily: "'Poppins',system-ui,sans-serif",
            lineHeight: 1,
          }}
        >
          DOLM IT
        </div>
        <div
          style={{
            fontSize: subSize,
            color: C.slateMut,
            fontWeight: 500,
            letterSpacing: 0.6,
            textTransform: "uppercase",
            marginTop: 3,
            fontFamily: "'Source Sans Pro',system-ui,sans-serif",
          }}
        >
          Resource Planner
        </div>
      </div>
    </div>
  );
};
